import React, { createContext, useContext, useState } from 'react';
import ConfirmDialog from './ConfirmDialog';

const ConfirmDialogContext = createContext();

export const ConfirmDialogProvider = ({ children }) => {
    const [dialogState, setDialogState] = useState({
        visible: false,
        message: '',
        process: 'save',
        onConfirm: () => { },
        onReject: () => { }
    });

    const showDialog = (options) => {
        setDialogState({
            visible: true,
            message: options.message || '',
            process: options.process || 'save',
            onConfirm: options.onConfirm || (() => { }),
            onReject: options.onReject || (() => { })
        });
    };

    const hideDialog = () => {
        setDialogState(prev => ({
            ...prev,
            visible: false
        }));
    };

    return (
        <ConfirmDialogContext.Provider value={{ showDialog, hideDialog }}>
            {children}
            <ConfirmDialog
                visible={dialogState.visible}
                setVisible={(visible) => setDialogState(prev => ({ ...prev, visible }))}
                onConfirm={dialogState.onConfirm}
                onReject={dialogState.onReject}
                process={dialogState.process}
                message={dialogState.message}
            />
        </ConfirmDialogContext.Provider>
    );
};

export const useConfirmDialog = () => {
    const context = useContext(ConfirmDialogContext);
    if (!context) {
        throw new Error('useConfirmDialog must be used within a ConfirmDialogProvider');
    }
    return context;
};